<template>
  <div>
    <keep-alive :include="['HomeEntry', 'Knowledge', 'Efficiency']">
      <router-view/>
    </keep-alive>

    <van-tabbar
      class="gc-tabbar-wrap"
      v-model="active"
      active-color="#D32F2F"
      inactive-color="#bfbfbf"
      :border="false"
    >
      <van-tabbar-item
        v-for="(item, index) in visibleTabbar"
        :key="index"
        :to="item.name"
        replace
      >
        <span>{{ item.title }}</span>
        <template #icon="props">
          <span v-if="item.chatgpt" class="chatgpt-icon" :class="{ active: props.active }">
            <svg viewBox="0 0 24 24" aria-hidden="true">
              <g fill="none" stroke="currentColor" stroke-width="1.65" stroke-linecap="round" stroke-linejoin="round">
                <path v-for="angle in [0,60,120,180,240,300]" :key="angle"
                      d="M12 3.1a3.25 3.25 0 0 1 3.25 3.25v3.2L12 11.4 8.75 9.55v-3.2A3.25 3.25 0 0 1 12 3.1Z" :transform="`rotate(${angle} 12 12)`"/>
              </g>
              <circle cx="12" cy="12" r="2.25" fill="none" stroke="currentColor" stroke-width="1.65"/>
            </svg>
          </span>
          <van-icon v-else :name="item.vantIcon" class="tabbar-icon" :class="{ active: props.active }"/>
        </template>
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
import {mobileMenu} from "@/config/menu";
import {hasPerm} from "@/utils/perm";

/** 底部 Tab 的权限门槛：与路由 permCode 保持一致，无权限直接不展示。 */
const TAB_PERMS = {
  "/knowledge": ["knowledge.document.read"],
  "/efficiency": ["efficiency.worklog.read"]
};

export default {
  name: 'Index',
  data() {
    return {
      active: 0,
      tabbar: [],
      bossMode: false
    };
  },
  computed: {
    isBoss() {
      return this.bossMode;
    },
    visibleTabbar() {
      return this.tabbar.filter(item => (!item.bossOnly || this.isBoss)
        && (!TAB_PERMS[item.name] || hasPerm(...TAB_PERMS[item.name])));
    }
  },
  mounted() {
    this.refreshMenu();
    window.addEventListener("brand-post-updated", this.refreshMenu);
    window.addEventListener("identity-updated", this.refreshMenu);
    let to = this.$router.currentRoute;
    this.tabChange(to);
  },
  beforeDestroy() {
    window.removeEventListener("brand-post-updated", this.refreshMenu);
    window.removeEventListener("identity-updated", this.refreshMenu);
  },
  watch: {
    $route(to, from) {
      this.refreshMenu();
      this.tabChange(to);
    }
  },
  methods: {
    refreshMenu() {
      this.bossMode = localStorage.getItem('isBoss') === '1' || localStorage.getItem('CoreIsBoss') === 'true';
      this.tabbar = mobileMenu({brandPost: localStorage.getItem("CoreBrandPost") || ""});
    },
    tabChange(to) {
      for (let i = 0; i < this.visibleTabbar.length; i++) {
        // 子路由也高亮对应 Tab（如 /efficiency/supervisor/reviews 高亮「全效」）
        if (to.path === this.visibleTabbar[i].name || to.path.startsWith(this.visibleTabbar[i].name + "/")) {
          this.active = i;
        }
      }
    }
  }
};
</script>

<style lang="less" scoped>
.gc-tabbar-wrap {
  box-shadow: 0rem 0rem 0.12rem 0rem rgba(211, 47, 47, 0.18);
}

.gc-tabbar-wrap /deep/ .van-tabbar-item__icon {
  font-size: 0.68rem;
  margin-bottom: 0.06rem;
}

.tabbar-icon {
  transition: transform .2s ease;
}

.tabbar-icon.active {
  transform: scale(1.08);
}

.chatgpt-icon {
  width: .68rem;
  height: .68rem;
  display: block;
  color: #bfbfbf
}

.chatgpt-icon.active {
  color: #D32F2F
}

.chatgpt-icon svg {
  width: 100%;
  height: 100%;
  display: block
}
</style>



// WEBPACK FOOTER //
// src/views/Index.vue